import { css } from '@emotion/react';
import { transparentize } from 'polished';

export default $ => css`
  .nav.nav-tabs {
    .nav-item {
      &.side-right {
        margin-left: auto;

        & ~ .side-right {
          margin-left: unset;
        }
      }
    }

    .nav-link {
      &:not(.active) {
        border-color: ${$.borderColor};
        color: ${$.primaryMain};
      }

      &:hover {
        background: ${transparentize(0.95, $.primaryMain)};
      }

      &.active {
        border-color: ${$.primaryMain};
        color: ${$.white};
        background-color: ${$.primaryMain};
      }
    }
  }

  .form-grouped-tabs {
    padding-right: 8px;
    padding-left: 8px;
  }

  .form-grouped-tabs.nav {
    gap: 16px;
    padding-bottom: 8px;
    justify-content: space-between;

    & > .nav-item,
    & > .nav-link {
      box-shadow: ${$.boxShadowSm};
    }

    .nav-item {
      width: min-content;
      &.dropdown.active {
        .dropdown-toggle {
          color: ${$.white};
          background-color: ${$.primaryMain};
        }
      }
    }

    .nav-link {
      border-radius: ${$.btnBorderRadius};
      padding-left: 12px;
      padding-right: 12px;
    }

    .dropdown-menu .dropdown-item {
      padding-left: 8px;
      padding-right; 8px;
    }

    .dropdown-header {
      font-style: italic;
    }

    .dropdown-item + .dropdown-header {
      margin-top: 8px;
    }
  }
`;
